import { AnyAction } from "redux";
import { actionTypeKeys } from "./actionTypeKeys";

export const closeAppAfterAppt = (): AnyAction => {
  return {
    type: actionTypeKeys.CLOSE_APP_AFTER_APPT
  };
};
